import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, App, Radio, Tooltip, } from 'antd';
import { useState } from 'react';
import { BranchesOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import FormModal from 'components/FormModal';
import { txt } from 'libs/i18n';
import { mergeSpeakers } from 'api/speaker-api-v2';
import { useSession } from 'components/Authenticated';
import SpeakerRadioItem from './SpeakerRadioItem';
import styles from './style.module.less';
const MergeModal = ({ open, onClose, selectedSpeakerRows, onSuccess, }) => {
    var _a, _b;
    const { session } = useSession();
    const { message } = App.useApp();
    const [primarySpeakerId, setPrimarySpeakerId] = useState((_b = (_a = selectedSpeakerRows[0]) === null || _a === void 0 ? void 0 : _a.uniqueId) !== null && _b !== void 0 ? _b : '');
    const [loading, setLoading] = useState(false);
    const handleSubmit = async () => {
        const speakerIdsToMerge = selectedSpeakerRows
            .filter((s) => s.uniqueId !== primarySpeakerId)
            .map((s) => s.uniqueId);
        setLoading(true);
        const result = await mergeSpeakers(session.connection, {
            primarySpeakerId,
            speakerIdsToMerge,
        });
        setLoading(false);
        if (result.isSuccess()) {
            void message.success(txt('speakersMerged'));
            await onSuccess(speakerIdsToMerge);
            onClose();
        }
        else {
            void message.error(txt('failedToFetchSpeaker'));
        }
    };
    const title = (_jsxs("span", { className: styles.titleWrapper, children: [_jsx(BranchesOutlined, {}), txt('mergeSpeakers')] }));
    return (_jsxs(FormModal, { open: open, onCancel: onClose, title: title, width: 520, onOk: handleSubmit, okText: txt('mergeSpeakers'), confirmLoading: loading, children: [_jsx(Alert, { type: "info", showIcon: true, message: txt('mergeSpeakersInfo'), className: styles.infoAlert }), _jsxs("h4", { className: styles.sectionTitle, children: [txt('targetSpeaker'), _jsx(Tooltip, { title: txt('targetSpeakerSection'), children: _jsx(QuestionCircleOutlined, { className: styles.infoIcon }) })] }), _jsx(Radio.Group, { className: styles.speakerList, value: primarySpeakerId, onChange: (e) => setPrimarySpeakerId(e.target.value), disabled: loading, children: selectedSpeakerRows.map((speaker) => (_jsx(SpeakerRadioItem, { speaker: speaker, isSelected: speaker.uniqueId === primarySpeakerId }, speaker.uniqueId))) })] }));
};
export default MergeModal;
